(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  function initAnnouncementBar(scope) {
    scope.querySelectorAll('[data-announcement-bar]').forEach((bar) => {
      if (bar.dataset.initialised === 'true') return;
      bar.dataset.initialised = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const messages = bar.querySelectorAll('[data-announcement-message]');
      if (messages.length < 2) return;

      const interval = Number(bar.dataset.interval) || 5000;
      let index = 0;

      setInterval(() => {
        messages[index].classList.add('is-hidden');
        index = (index + 1) % messages.length;
        messages[index].classList.remove('is-hidden');
      }, interval);
    });
  }

  initAnnouncementBar(document);

  document.addEventListener('shopify:section:load', (event) => {
    initAnnouncementBar(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.initialised === 'true') return;
    drawer.dataset.initialised = 'true';

    const open = () => {
      if (!drawer.open) drawer.showModal();
    };

    const setCount = (count) => {
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = String(count);
        node.classList.toggle('is-empty', count === 0);
      });
    };

    const refresh = async () => {
      const contents = drawer.querySelector('[data-cart-contents]');
      if (contents) contents.classList.add('is-loading');

      const response = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer`);
      const data = await response.json();
      const markup = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const next = markup.querySelector('[data-cart-contents]');
      if (next && contents) contents.replaceWith(next);

      const cart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
      setCount(cart.item_count);
    };

    /* Ouverture depuis l'icône panier de l'en-tête. */
    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-cart-toggle]');
      if (toggle) {
        event.preventDefault();
        open();
        return;
      }

      const close = event.target.closest('[data-cart-close]');
      if (close) {
        drawer.close();
        return;
      }

      const change = event.target.closest('[data-quantity-change]');
      if (change && drawer.contains(change)) {
        const line = change.closest('[data-cart-item]');
        if (!line) return;
        event.preventDefault();
        fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: Number(line.dataset.line),
            quantity: Number(change.dataset.quantityChange),
          }),
        }).then(refresh);
      }
    });

    /* Clic sur le fond : fermeture. */
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) drawer.close();
    });

    /* Ajout au panier en AJAX depuis n'importe quel formulaire produit. */
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-product-form]');
      if (!form) return;

      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      if (button) button.classList.add('is-loading');

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          body: new FormData(form),
        });

        if (!response.ok) {
          const error = await response.json();
          const status = form.querySelector('[data-form-status]');
          if (status) status.textContent = error.description || error.message || '';
          return;
        }

        await refresh();
        open();
      } finally {
        if (button) button.classList.remove('is-loading');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compression-technology"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-compression]');
    if (!sections.length) return;

    sections.forEach((section) => {
      const chambers = section.querySelectorAll('.compression__chamber');
      const steps = section.querySelectorAll('[data-compression-step]');
      const counter = section.querySelector('[data-compression-counter]');
      if (!chambers.length) return;

      const setProgress = (index) => {
        chambers.forEach((chamber, i) => {
          chamber.classList.toggle('is-active', i <= index);
        });
        if (counter) counter.textContent = String(Math.min(index + 1, chambers.length));
        if (steps.length) {
          const stepIndex = Math.min(
            Math.floor((index / chambers.length) * steps.length),
            steps.length - 1
          );
          steps.forEach((step, i) => step.classList.toggle('is-current', i === stepIndex));
        }
      };

      /* Sans animation (reduced-motion ou GSAP indisponible) : état final lisible. */
      const showStatic = () => setProgress(chambers.length - 1);

      window
        .sowellbeMotion()
        .then(({ gsap, ScrollTrigger }) => {
          const grid = section.querySelector('.compression__grid');
          const state = { value: -1 };

          gsap.to(state, {
            value: chambers.length - 1,
            ease: 'none',
            onUpdate: () => setProgress(Math.round(state.value)),
            scrollTrigger: {
              trigger: section,
              start: 'top top',
              end: '+=' + window.innerHeight * 1.6,
              scrub: 0.6,
              pin: grid,
              pinSpacing: true,
              invalidateOnRefresh: true,
            },
          });

          setProgress(0);
          ScrollTrigger.refresh();
        })
        .catch(showStatic);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initHeader(scope) {
    const dialog = scope.querySelector('[data-mobile-menu]');
    if (!dialog || dialog.dataset.initialised === 'true') return;
    dialog.dataset.initialised = 'true';

    const openButton = scope.querySelector('[data-menu-open]');
    const closeButton = dialog.querySelector('[data-menu-close]');

    const setExpanded = (value) => {
      if (openButton) openButton.setAttribute('aria-expanded', String(value));
    };

    if (openButton) {
      openButton.addEventListener('click', () => {
        dialog.showModal();
        setExpanded(true);
      });
    }

    if (closeButton) {
      closeButton.addEventListener('click', () => dialog.close());
    }

    dialog.addEventListener('close', () => setExpanded(false));

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  }

  initHeader(document);

  document.addEventListener('shopify:section:load', (event) => {
    initHeader(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-parallax]');
    if (!sections.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    window
      .sowellbeMotion()
      .then(({ gsap }) => {
        sections.forEach((section) => {
          const layer = section.querySelector('[data-parallax-layer]');
          if (!layer) return;

          gsap.fromTo(
            layer,
            { yPercent: -6 },
            {
              yPercent: 6,
              ease: 'none',
              scrollTrigger: {
                trigger: section,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
              },
            }
          );
        });
      })
      .catch(() => {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    /* ---------- Galerie : miniatures ---------- */
    document.querySelectorAll('[data-gallery]').forEach((gallery) => {
      const stage = gallery.querySelector('[data-gallery-stage]');
      const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      const slides = gallery.querySelectorAll('[data-gallery-slide]');
      if (!stage || !thumbs.length) return;

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = Number(thumb.dataset.galleryThumb);
          const slide = slides[index];
          if (slide) stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
        });
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const index = Number(entry.target.dataset.gallerySlide);
            thumbs.forEach((thumb, i) => thumb.classList.toggle('is-current', i === index));
          });
        },
        { root: stage, threshold: 0.6 }
      );

      slides.forEach((slide) => observer.observe(slide));
    });

    /* ---------- Quantité ---------- */
    document.querySelectorAll('[data-product-quantity]').forEach((widget) => {
      const input = widget.querySelector('input');
      if (!input) return;
      widget.querySelectorAll('[data-quantity-step]').forEach((button) => {
        button.addEventListener('click', () => {
          const next = Number(input.value) + Number(button.dataset.quantityStep);
          input.value = String(Math.max(1, next));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* ---------- Sélection de variante ---------- */
    const picker = document.querySelector('[data-variant-picker]');
    const info = document.querySelector('[data-product-info]');

    if (picker && info) {
      const dataNode = picker.querySelector('[data-variant-data]');
      const variants = dataNode ? JSON.parse(dataNode.textContent) : [];
      const idInput = info.querySelector('[data-variant-id]');
      const addButton = info.querySelector('[data-add-button]');
      const addLabel = info.querySelector('[data-add-label]');
      const stickyButton = document.querySelector('[data-sticky-add]');
      /* Bloc de réassort en mode auto : il suit la taille sélectionnée. Sans ça,
         réapprovisionner une seule taille laisse le formulaire visible sur une
         taille disponible — ou l'inverse, ce qui est pire. */
      const restock = document.querySelector('[data-restock][data-restock-auto]');
      /* Le formulaire de réassort doit repartir avec la taille que le client
         regardait : c'est toute la valeur de l'inscription côté commerçante. */
      const restockSize = document.querySelector('[data-restock-size]');

      /* Les libellés traduits viennent du DOM : ce bloc est servi en fichier
         statique et ne peut donc pas contenir de Liquid. */
      const labels = {
        add: addButton ? addButton.dataset.labelAdd : '',
        soldOut: addButton ? addButton.dataset.labelSoldOut : '',
        unavailable: addButton ? addButton.dataset.labelUnavailable : '',
      };

      const currentSelection = () =>
        Array.from(picker.querySelectorAll('input:checked'))
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map((input) => input.value);

      const update = () => {
        const selection = currentSelection();

        picker.querySelectorAll('[data-selected-for]').forEach((node, index) => {
          node.textContent = selection[index] || '';
        });

        const match = variants.find((variant) =>
          variant.options.every((option, index) => option === selection[index])
        );

        if (idInput) {
          idInput.value = match ? match.id : '';
          idInput.disabled = !match || !match.available;
        }

        const enabled = Boolean(match && match.available);

        [addButton, stickyButton].forEach((button) => {
          if (!button) return;
          button.disabled = !enabled;
        });

        if (addLabel) {
          if (!match) addLabel.textContent = labels.unavailable;
          else if (!match.available) addLabel.textContent = labels.soldOut;
          else addLabel.textContent = labels.add;
        }

        if (restock) {
          restock.hidden = enabled;
        }

        if (restockSize && match) {
          const option = restockSize.querySelector('option[data-variant-id="' + match.id + '"]');
          if (option) restockSize.value = option.value;
        }

        if (match) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url);
        }
      };

      picker.addEventListener('change', update);
      update();
    }

    /* ---------- Bouton d'achat collant ---------- */
    const sticky = document.querySelector('[data-sticky-atc]');
    const form = document.querySelector('[data-product-form]');

    if (sticky && form) {
      sticky.hidden = false;

      const stickyAdd = sticky.querySelector('[data-sticky-add]');
      if (stickyAdd) {
        stickyAdd.addEventListener('click', () => form.requestSubmit());
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      );

      observer.observe(form);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-angle-demo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-angles]');
    if (!sections.length) return;

    sections.forEach((section) => {
      const head = section.querySelector('[data-angle-head]');
      const items = Array.from(section.querySelectorAll('[data-angle-item]'));
      const marks = Array.from(section.querySelectorAll('[data-angle-mark]'));
      if (!head || !items.length) return;

      const PIVOT = '161 104';
      const rotations = items.map((item) => Number(item.dataset.rotation) || 0);

      const applyIndex = (index) => {
        items.forEach((item, i) => item.classList.toggle('is-current', i === index));
        marks.forEach((mark, i) => mark.classList.toggle('is-current', i === index));
      };

      window
        .sowellbeMotion()
        .then(({ gsap, ScrollTrigger }) => {
          const grid = section.querySelector('.angles__grid');
          const visual = section.querySelector('.angles__visual');

          gsap.set(head, { svgOrigin: PIVOT, rotation: rotations[0] });
          applyIndex(0);

          /* L'angle courant se déduit de la rotation réelle : le même calcul
             sert au scrub du desktop et à la lecture libre du mobile. */
          const syncCurrent = () => {
            const current = Number(gsap.getProperty(head, 'rotation')) || 0;
            let nearest = 0;
            let distance = Infinity;
            rotations.forEach((value, i) => {
              const delta = Math.abs(value - current);
              if (delta < distance) {
                distance = delta;
                nearest = i;
              }
            });
            applyIndex(nearest);
          };

          /* Une position se comprend quand elle tient en place. La timeline
             alterne donc palier et transition : la tête s'arrête visiblement
             sur chaque angle au lieu de balayer d'un trait de 0 à 90. */
          const choreograph = (timeline) => {
            timeline.to({}, { duration: 0.6 });
            for (let i = 1; i < rotations.length; i += 1) {
              timeline.to(head, { rotation: rotations[i], duration: 1 });
              timeline.to({}, { duration: 0.6 });
            }
            return timeline;
          };

          const media = gsap.matchMedia();

          /* Desktop : la colonne tient dans l'écran, on peut la figer et confier
             la rotation au scroll. */
          media.add('(min-width: 990px)', () => {
            choreograph(
              gsap.timeline({
                defaults: { ease: 'power2.inOut', svgOrigin: PIVOT },
                scrollTrigger: {
                  trigger: section,
                  start: 'top top',
                  end: '+=' + Math.round(window.innerHeight * 1.9),
                  scrub: 0.9,
                  pin: grid,
                  pinSpacing: true,
                  anticipatePin: 1,
                  invalidateOnRefresh: true,
                  onUpdate: syncCurrent,
                },
              })
            );

            return () => applyIndex(0);
          });

          /* Mobile : surtout pas de pin. En dessous de 990 px la colonne est plus
             haute que l'écran ; la figer plaçait le schéma sous la ligne de
             flottaison et toute l'animation se jouait hors champ — on scrollait
             sans jamais voir le pistolet.
             Le repère n'est donc plus la section mais le schéma lui-même, et la
             fenêtre de scrub se referme quand il est encore bien dans l'écran :
             la rotation se termine sous les yeux du client, quelle que soit sa
             vitesse de défilement. */
          media.add('(max-width: 989px)', () => {
            choreograph(
              gsap.timeline({
                defaults: { ease: 'power2.inOut', svgOrigin: PIVOT },
                scrollTrigger: {
                  trigger: visual,
                  start: 'top bottom-=10%',
                  end: 'bottom center',
                  scrub: 0.8,
                  invalidateOnRefresh: true,
                  onUpdate: syncCurrent,
                },
              })
            );

            return () => applyIndex(0);
          });

          ScrollTrigger.refresh();
        })
        .catch(() => {
          applyIndex(0);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sowellbe-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const heroes = document.querySelectorAll('.hero [data-hero-line]');
    if (!heroes.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    window
      .sowellbeMotion()
      .then(({ gsap }) => {
        gsap.set(heroes, { autoAlpha: 0, y: 28 });
        gsap.to(heroes, {
          autoAlpha: 1,
          y: 0,
          duration: 1.1,
          ease: 'power3.out',
          stagger: 0.12,
          delay: 0.15,
        });
      })
      .catch(() => {});
  })();

  } catch(e) { console.error(e); }
})();
})();
